export const ticketPlatformSearch = (ticketList, searchText = "") => {
  if (!searchText || searchText.trim() === "") return ticketList;
  const searchWordList = searchText.toLowerCase().split(" ");

  return ticketList.filter((ticket) => {
    const eventName = ticket?.event?.name?.toLowerCase() || "";
    const playerName = ticket?.playerName.toLowerCase() || "";
    const orderId = ticket?.orderId?.toLowerCase() || "";
    const status = ticket?.status?.toLowerCase() || "";

    let i = 0;
    let result = true;

    while (i < searchWordList.length && result) {
      if (
        !(
          eventName.includes(searchWordList[i]) ||
          playerName.includes(searchWordList[i]) ||
          orderId.includes(searchWordList[i]) ||
          status.includes(searchWordList[i])
        )
      ) {
        result = false;
      }
      i++;
    }

    return result;
  });
};
